export default function Header() {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex items-center justify-center gap-4">
          <a href="/" className="flex-shrink-0 cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/f1769650ef219847a82938b2ccb51dd4/b20bf12da98b13bf6586d3e638cf3b35.jpeg" 
              alt="Next Stage Logo" 
              className="h-12 w-auto md:h-14"
              fetchPriority="high"
              decoding="async"
            />
          </a>
          <span className="text-2xl md:text-4xl font-bold text-gray-900">
            コインランドリー経営.com<span className="hidden">.com</span>
          </span>
        </div>
      </div>
    </header>
  );
}
